import { httpClient } from '@/services/http/httpClient'

import type { User } from '../types'

export type GetMeResponse = {
  user: User
}

export async function getMe(): Promise<GetMeResponse> {
  const { data } = await httpClient.get(`/users/me`)
  return data
}
